module.exports = __webpack_public_path__ + "img/section7-2.c79d16fd.svg";